// falsy values are: false, 0, '', null, undefined, NaN
// eslint-disable-next-line import/prefer-default-export
export function isFalsy(value) {
  return !value
}
